// extracted by mini-css-extract-plugin
module.exports = {"userList":"Users_userList__2GiLO","userItem":"Users_userItem__32rXZ"};